import React, { useState, useEffect } from 'react'
import { Button, Modal, Select } from "antd";
import { paymentOption } from '../../constants';
import IsEmpty from '../../../../components/helpers/IsEmpty';
import ErrorDiv from '../../../../components/helpers/ErrorDiv';
import { getLabel } from '../helpers/getLabel';
import { MdContentCopy } from "react-icons/md";
import SwalToast from '../../../../components/helpers/SwalToast';
import { CurrencyFormat } from '../../../../components/helpers';
const { Option } = Select;

export default function ModalPaymentMethod({
    visible,
    handleClose,
    data,
    sbg,
    paymentMethod,
    onChangePayment,
    bankList,
    onChangeBank,
    bankValue,
    submitTransferPayment,
    submitCashPayment,
    VA,
    submitting,
    onRefresh,
    paymentType,
    dataBalloon,
    totalBill,
    totalVoucherAmount
}) {
    const [isConfirm, setIsConfirm] = useState(false);
    const [bankLabel, setBankLabel] = useState('');
    const [error, setError] = useState(false);

    const confirm = () => {
        if (paymentMethod === paymentOption[1].value && IsEmpty(bankValue)) {
            setError(true)
        } else {
            setError(false)
            setIsConfirm(true)
        }
    }

    const onChange = (e) => {
        setBankLabel(getLabel(bankList, e))
        onChangeBank(e)
    }

    const submit = () => {
        if (!IsEmpty(VA)) {
            onRefresh()
        } else if (isConfirm) {
            if (paymentMethod === 'transfer') {
                submitTransferPayment()
            } else if (paymentMethod === 'cash') {
                submitCashPayment()
            }
        } else {
            confirm()
        }
    }

    const onClose = () => {
        setIsConfirm(false)
        if (!isConfirm) {
            handleClose()
        }
    }

    const copyToClipbord = () => {
        navigator.clipboard.writeText(VA)
        SwalToast.fire({
            icon: "success",
            title: 'Nomor Virtual Account berhasil di copy',
        });
    }
    console.log('dataa', dataBalloon)
    return (
        <Modal
            title={!isConfirm ? "Pilih Metode Pembayaran" : 'Konfirmasi Pembayaran'}
            visible={visible}
            onCancel={() => {
                handleClose()
                setIsConfirm(false)
            }}
            width={600}
            centered
            footer={[
                <Button
                    disabled={submitting}
                    key="back"
                    onClick={onClose}
                    className="btn-modal btn-default"
                    style={{ width: "15%" }}
                >
                    Kembali
                </Button>,
                <Button
                    disabled={submitting}
                    key="submit"
                    type="primary"
                    onClick={submit}
                    className="btn-modal"
                    style={{ width: "15%" }}
                >
                    {!IsEmpty(VA) ? 'Refresh' : isConfirm ? 'Bayar' : 'Lanjut'}
                </Button>,
            ]}
        >
            <div className="py-2">
                {isConfirm && <div className='my-2 text-center' style={{ fontWeight: '600' }}>Pastikan kembali pembayaran sudah sesuai</div>}


                {!IsEmpty(VA) &&
                    <>
                        <div className='my-2 text-center' style={{ fontWeight: '500', color: '#A6A6A6' }}>Nomor Virtual Account</div>
                        <div className='d-flex align-items-center justify-content-center'>
                            <div className='my-2 text-center' style={{ fontWeight: '700', fontSize: 24, color: '#2C465C' }}>{VA}</div>
                            <MdContentCopy onClick={copyToClipbord} className='ml-2' size={24} style={{ color: "#2C465C", cursor: "pointer" }} />
                        </div>
                    </>
                }
                <div className='row my-3'>
                    <div className='col-4'>No. SBG:</div>
                    <div className='col-8' style={{ fontWeight: '700' }}>{sbg}</div>
                </div>

                {
                    paymentType === 'Installment' &&
                    <>
                        {
                            data.map((item, index) => {
                                if (item.isChecked) {
                                    return (
                                        <div key={index} className='row justify-content-between mb-3'>
                                            <div className='col-4'>Tagihan Cicilan Ke-{item.periodNumber}:</div>
                                            <div className='col-8'>
                                                <div style={{ fontWeight: '700' }}>{item.totalBill}</div>
                                                <div style={{ color: '#A6A6A6' }}>Tagihan Pokok : {item.installmentAmount}</div>
                                                {
                                                    item.interestType.includes('behind') &&
                                                    <>
                                                        <div style={{ color: '#A6A6A6' }}>Biaya Sewa Modal : {item.capitalLoan}</div>
                                                        {item.interestType === 'behind' &&
                                                            <>
                                                                <div style={{ color: '#A6A6A6' }}>Biaya Admin : {item.feeAdmin}</div>
                                                                <div style={{ color: '#A6A6A6' }}>Biaya Simpan & Asuransi : {item.feeSavingInsurance}</div>
                                                            </>}
                                                    </>
                                                }
                                                <div style={{ color: '#A6A6A6' }}>Denda Harian : {item.lateDays}</div>
                                                <div style={{ color: '#A6A6A6' }}>Biaya Keterlambatan : {item.latePeriod}</div>
                                                <div style={{ color: '#A6A6A6' }}>Periode : {item.periode}</div>
                                                {
                                                    JSON.stringify(item.voucher) !== '{}' &&
                                                    <>
                                                        <div style={{ color: '#A6A6A6' }}>Voucher : <span style={{ color: '#2C465C' }}>{item.voucher?.name}</span></div>
                                                        <div style={{ color: '#A6A6A6' }}>Jumlah Potongan : <span style={{ color: '#F23434' }}>- {item.voucher?.amountCurrency}</span></div>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </>
                }

                {
                    paymentType === 'Balloon Payment' &&
                    <div className='row justify-content-between mb-3'>
                        <div className='col-4'>Total Tagihan :</div>
                        <div className='col-8'>
                            <div style={{ fontWeight: '700' }}>{dataBalloon.bill?.total}</div>
                            <div style={{ color: '#A6A6A6' }}>Tagihan Pokok : {dataBalloon.bill?.loanAmount}</div>
                            <div style={{ color: '#A6A6A6' }}>Denda Keterlambatan : {dataBalloon.bill?.lateCharge}</div>
                            <div style={{ color: '#A6A6A6' }}>Simpan & Asuransi Keterlambatan : {dataBalloon.bill?.savingLateCharge}</div>
                        </div>
                    </div>
                }
                {paymentType === 'Installment' ?
                    totalVoucherAmount > 0 &&
                    <div className='row justify-content-between mb-3'>
                        <div className='col-4'>Jumlah Potongan :</div>
                        <div className='col-8' style={{ fontWeight: '700', color: '#F23434' }}>- Rp {CurrencyFormat(totalVoucherAmount)}</div>
                    </div>
                    :
                    dataBalloon?.additionalData?.voucher?.length > 0 &&
                    <div className='row justify-content-between mb-3'>
                        <div className='col-4'>Jumlah Potongan :</div>
                        <div className='col-8' style={{ fontWeight: '700', color: '#F23434' }}>- Rp {CurrencyFormat(dataBalloon?.additionalData?.voucher[0].voucher_amount)}</div>
                    </div>
                }
                {paymentType === 'Installment' ?
                    isConfirm ?
                        <div className='row justify-content-between mb-3'>
                            <div className='col-4'>Total Pembayaran :</div>
                            <div className='col-8' style={{ fontWeight: '700' }}>Rp {CurrencyFormat(totalBill - totalVoucherAmount)}</div>
                        </div>
                        :
                        <div className='row justify-content-between mb-3'>
                            <div className='col-4'>Total Tagihan :</div>
                            <div className='col-8' style={{ fontWeight: '700' }}>Rp {CurrencyFormat(totalBill)}</div>
                        </div>
                    :
                    <div className='row justify-content-between mb-3'>
                        <div className='col-4'>Total Pembayaran :</div>
                        <div className='col-8' style={{ fontWeight: '700' }}>{dataBalloon?.bill?.totalWithVoucher}</div>
                    </div>
                }
                {isConfirm ?
                    <>
                        <div className='row justify-content-between mb-3'>
                            <div className='col-4'>Metode Pembayaran :</div>
                            <div className='col-8' style={{ fontWeight: '700' }}>{paymentMethod === 'cash' ? 'Tunai' : 'Non-Tunai'}</div>
                        </div>
                        {paymentMethod === paymentOption[1].value &&
                            <div className='row justify-content-between mb-3'>
                                <div className='col-4'>Bank :</div>
                                <div className='col-8' style={{ fontWeight: '700' }}>{bankLabel}</div>
                            </div>
                        }
                    </>
                    :
                    <>
                        <div className='row justify-content-between mb-3'>
                            <div className='col-4'>Metode Pembayaran :</div>
                            <div className='col-8 w-100'>
                                <Select
                                    value={paymentMethod}
                                    onChange={onChangePayment}
                                    className="w-100"
                                >{paymentOption.map(item => <Option value={item.value}>{item.label}</Option>)}
                                </Select>
                            </div>
                        </div>
                        {paymentMethod === paymentOption[1].value &&
                            <div className='row justify-content-between mb-3'>
                                <div className='col-4'>Bank :</div>
                                <div className='col-8 w-100'>
                                    <Select
                                        value={bankValue}
                                        onChange={onChange}
                                        className="w-100"
                                    >{bankList.map(item => <Option value={item.value}>{item.label}</Option>)}
                                    </Select>
                                    {error && <ErrorDiv error="Bank harus dipilih" />}
                                </div>
                            </div>
                        }
                    </>
                }
            </div>
        </Modal>
    )
}
